import styled from "styled-components";

const Container = styled.div`
    position: fixed;
    bottom: 80px; 
    right: 50px;
    z-index: 100px;
    background: #F5F5F5;
    border-radius: 30px;
    padding: 5px 7px;
    color: #9D9D9D;
    font-size: 14px;
    height: 50px;
    width: 176px;

    span{
      margin-right: 17px;
      line-height: 40px;
      position: absolute;
      top: 5px;
      left: 21px;
    }

    button{
      background: white;
      float: right;
    }

    @media (max-width: 720px) {
      padding: 5px 7px;
      bottom: 90px; 
      right: 25px;
      width: auto;

      span{
        display: none;
      }
    }
`;

export default Container;